module.exports = __webpack_public_path__ + "static/media/quote-icon.d1dddd6e.svg";